<template lang="pug">
.card-inteligencia-territorial-dados-gerais-imoveis
    .card-inteligencia-territorial-imoveis-interno--texto
        .card-inteligencia-territorial-imoveis-interno--titulo(
            style='width:100%'
        ) {{ $t('mensagens.inteligenciaTerritorial.imovel.outros') }}
            .card-inteligencia-territorial-imoveis-interno--valor
                span.conteudo-informativo.red {{ formatoNumero(0) }} ha
</template>
<script>
import formatters from '@/utils/formatters';

export default {
    name: 'CardInteligenciaTerritorialPotencialAgropecuarioImovel',
    props: {
        areaTotal: {
            type: Object,
            default: () => {
            }
        }
    },

    data() {
        return {};
    },

    methods: {
        formatoNumero(number) {
            return number ? formatters.formatNumber(number, 2) : 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.card-inteligencia-territorial-dados-gerais-imoveis {
    height: 80px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    justify-content: flex-start;
    padding: 7px 15px;
    color: var(--primary);
    box-shadow: 0px 0px 10px 0px #0000001A;

    .card-inteligencia-territorial-imoveis-interno--titulo {
        padding-top: 0px;
        font-size: 16px;
        font-weight: 400;
        flex-wrap: wrap;
        margin-top: 14px;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
    }

    .card-inteligencia-territorial-imoveis-interno--texto {
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        min-height: 77px;
        margin-left: 12px;
        width: 100%;
        color: #3B3B3B;

        span {
            margin-top: 6px;
        }
    }

    .card-inteligencia-territorial-imoveis-interno--valor {
        display: flex;
        padding-top: 1px;
        margin-bottom: 5%;
    }

    .conteudo-informativo {
        font-size: 18px;
        font-weight: 500;
        line-height: 21px;
        letter-spacing: 0em;
        color: var(--primary);
    }

    .red {
        color: red;
    }
}
</style>
